<template>
  <div class="user-user" :style="{ '--height': height, }">
    <div class="index-view-top">
      <van-icon name="cross" style="opacity: 0" size="28" color="#ffffff" />
      <div class="title">{{ $t("head.user") }}</div>
      <van-icon name="ellipsis" style="opacity: 0" size="28" color="#ffffff" />
    </div>
    <div class="user-scroll">
      <div class="userInfo">
        <img v-if="userInfo.head" class="header" :src="baseUrl + userInfo.head" alt="" />
        <img v-else class="header" alt="" src="../assets/common.jpg" />
        <div class="userInfo-center">
          <div>{{ userInfo.account }}</div>
          <div style="color: #999999">UID：{{ userInfo.inviteCode }}</div>
        </div>
        <van-icon name="arrow" style="margin-left: auto" size="24" color="#999999" @click="toUserInfo" />
      </div>
      <div class="user-card">
        <div>
          <div class="card-top">
            <div></div>
            <div>{{ $t("user.wallet_account") }}</div>
            <div>
              <p @click="toBalance(0)">{{ $t("user.balance") }}</p>
            </div>
          </div>
          <div class="card-center">
            <div>{{ walletInfo.usdtUsedPrice }} USDT</div>
            <div>{{ walletInfo.trxUsedPrice }} TRX</div>
          </div>
          <div class="card-bottom">
            <div @click="$router.push('/recharge')">
              <p>{{ $t("user.top_up") }}</p>
            </div>
            <div>
              <p @click="withdrawal(0)">{{ $t("user.withdrawal") }}</p>
            </div>
          </div>
        </div>
      </div>
      <div class="my-wallet">
        <div class="my-wallet-left">{{ this.$t("user.my_wallet") }}</div>
        <div class="my-wallet-right" @click="add_address">
          <img src="../assets/tjqb.png" alt="" />
          <p>{{ $t("user.add_wallet") }}</p>
        </div>
      </div>
      <div class="add-my-wallet">
        <div v-if="walletLists.length > 0">
          <div v-for="(item, index) in walletLists.slice(0, 1)" :key="index">
            <div class="top">
              <p>{{
                  item.address.slice(0, 10) + '......' + item.address.slice(item.address.length - 10,
                    item.address.length)
              }}</p>
            </div>
            <div class="center">
              <div class="number">
                <p>USDT：</p>
                <p>{{ item.usdt || '0.00' }}</p>
              </div>
              <div class="number">
                <p>TRX：</p>
                <p>{{ item.trx || '0.00' }}</p>
              </div>
              <div class="code" @click="transactiondetails(item.address)">{{ $t("user.look")
              }}></div>
            </div>
          </div>
          <div v-if="show">
            <div v-for="(item, index) in walletLists.slice(1, walletLists.length)" :key="index">
              <div class="top">
                <p>{{
                    item.address.slice(0, 10) + '......' + item.address.slice(item.address.length - 10,
                      item.address.length)
                }}</p>
              </div>
              <div class="center">
                <div class="number">
                  <p>USDT：</p>
                  <p>{{ item.usdt || '0.00' }}</p>
                </div>
                <div class="number">
                  <p>TRX：</p>
                  <p>{{ item.trx || '0.00' }}</p>
                </div>
                <div class="code" @click="transactiondetails(item.address)">{{
                    $t("user.look")
                }}></div>
              </div>
            </div>
          </div>
          <div class="bottom" @click="moreWalletLists" v-if="!show">
            <p>{{ $t("user.look_all") }}</p>
            <van-icon name="arrow-down" size="16" color="#999999" />
          </div>
          <div class="bottom" @click="show = false" v-if="show">
            <p>{{ $t("user.Pack_up") }}</p>
            <van-icon name="arrow-up" size="16" color="#999999" />
          </div>
        </div>
      </div>
      <div class="menu-lists">
        <div @click="toVip">
          <img src="../assets/1.png" alt="" />
          <p>VIP</p>
        </div>
        <div @click="toVip">
          <img src="../assets/2.png" alt="" />
          <p>{{ $t("tabbar.activity") }}</p>
        </div>
        <!-- <div @click="bettingRecord()">
          <img
            src="../assets/3.png"
            alt=""
          />
          <p>{{ $t("user.bettingRecord") }}</p>
        </div> -->
        <div @click="toSpread">
          <img src="../assets/4.png" alt="" />
          <p>{{ $t("user.reward") }}</p>
        </div>
        <div @click="goCustomerLink">
          <img src="../assets/5.png" alt="" />
          <p>{{ $t("user.goCustomerLink") }}</p>
        </div>
      </div>
      <div class="user-card-other">
        <div>
          <div class="card-top">
            <div></div>
            <div>{{ $t("user.Commission_account") }}</div>
            <div @click="toBalance(1)">
              <p>{{ $t("phone.yjmx") }}</p>
            </div>
          </div>
          <div class="card-center">
            <div>{{ inviteInfo.usdtUsedPrice }} USDT</div>
            <div>{{ inviteInfo.trxUsedPrice }} TRX</div>
          </div>
          <div class="card-bottom">
            <div @click="withdrawal(1)">
              <p>{{ $t("user.withdrawal") }}</p>
            </div>
            <div @click="toTransfer">
              <p>{{ $t("user.transfer") }}</p>
            </div>
          </div>
        </div>
      </div>
      <div class="my-group">
        <div class="top">
          <p>{{ $t("user.number") }}</p>
          <p @click="transactiondetails('')">{{ $t("user.transactiondetails") }}</p>
        </div>
        <div class="money">
          <p :class="moneyType == 'USDT' ? 'active' : ''" @click="changeMoneyType('USDT')">USDT</p>
          <p :class="moneyType == 'TRX' ? 'active' : ''" @click="changeMoneyType('TRX')">TRX</p>
        </div>
        <div class="win">
          <div class="win-card">
            <div>
              <div>{{ batInfoLists.todayBat || '0' }} {{ moneyType }}</div>
              <div>{{ $t("user.day") }}</div>
            </div>
            <img src="../assets/mj.png" alt="" />
          </div>
          <div class="win-card">
            <div>
              <div>{{ batInfoLists.todayAward || '0' }} {{ moneyType }}</div>
              <div>{{ $t("user.day_winning") }}</div>
            </div>
            <img src="../assets/mj.png" alt="" />
          </div>
        </div>
      </div>
      <div class="other-about">
        <div class="other-about-item" @click="myteam">
          <img src="../assets/11.png" alt="" />
          <p>{{ $t("user.my_team") }}</p>
          <van-icon name="arrow" style="margin-left: auto" size="22" color="#999999" />
        </div>
        <div class="other-about-item" @click="about">
          <img src="../assets/12.png" alt="" />
          <p>{{ $t("user.about_we") }}</p>
          <van-icon name="arrow" style="margin-left: auto" size="22" color="#999999" />
        </div>
        <div class="other-about-item" @click="goCustomerLink">
          <img src="../assets/13.png" alt="" />
          <p>{{ $t("user.center") }}</p>
          <van-icon name="arrow" style="margin-left: auto" size="22" color="#999999" />
        </div>
        <div class="other-about-item" style="border: none" @click="$router.push('/setting')">
          <img src="../assets/14.png" alt="" />
          <p>{{ $t("user.setting") }}</p>
          <van-icon name="arrow" style="margin-left: auto" size="22" color="#999999" />
        </div>
      </div>
    </div>
    <tabbar class="footer-tabbar" :tabbarType="'5'" @changeActiveStatus="changeActiveStatus"></tabbar>
  </div>
</template>

<script>
import { info, walletInfo, contact, myWallet, batInfo } from '@/utils/request'
import { BASEURL } from '@/utils/http'
import { Dialog } from 'vant'
import { mapState } from 'vuex'
import tabbar from '../components/tabbar' //**引入底部导航栏**
export default {
  components: {
    tabbar
  },
  data() {
    return {
      moneyType: 'USDT',
      // userInfo: '',
      walletInfo: '',
      inviteInfo: '', //佣金账户
      customer: '', //客服链接
      show: false,
      height: '', //屏幕高度
      walletLists: '', //我的钱包
      balanceTimer: '',
      allBalanceTimer: '',
      batInfoLists: '', //投注数据
      baseUrl: ''
    }
  },
  computed: {
    ...mapState(['userInfo'])
  },
  //获取屏幕高度
  created() {
    let h = document.documentElement.clientHeight || document.body.clientHeight;
    if (h > 0) {
      this.height = h + 'px' //页面高度
    } else {
      this.height = "100vh"
    }
  },
  mounted() {
    this.baseUrl = BASEURL
    this.getUserInfo()
    this.getWallet()
  },
  beforeDestroy() {
    clearInterval(this.balanceTimer)
    clearInterval(this.allBalanceTimer)
  },
  methods: {
    getWallet() {
      myWallet().then(res => {
        if (res.code == '200') {
          res.data.records.map(async (item, index) => {
            item.usdt = ((await this.getUsdtBalance(item.address)) / 1000000).toFixed(2)
            item.trx = ((await this.getTrxBalance(item.address)) / 1000000).toFixed(2)
          })
          this.balanceTimer = setInterval(() => {
            clearInterval(this.balanceTimer)
            this.walletLists = res.data.records
            this.getWallet()
          }, 2000);
        }
      })
    },
    //获取用户信息，客服链接、钱包余额、绑定钱包列表
    getUserInfo() {
      clearInterval(this.allBalanceTimer)
      info().then(res => {
        if (res.code == '200') {
          // this.userInfo = res.data
          this.$store.commit('setUserInfo', res.data)
        }
      })
      contact().then(res => {
        if (res.code == '200') {
          this.customer = res.data.url
        }
      })
      batInfo({ coin: this.moneyType }).then(res => {
        if (res.code == '200') {
          this.batInfoLists = res.data
        }
      })
      //顶部余额自动更新
      this.allBalanceTimer = setInterval(() => {
        walletInfo({ kind: '0' }).then(result => {
          if (result.code == '200') {
            this.walletInfo = result.data
          }
        })
        walletInfo({ kind: '1' }).then(result => {
          if (result.code == '200') {
            this.inviteInfo = result.data
          }
        })
      }, 1000)

    },
    changeMoneyType(item) {
      this.batInfoLists = ''
      this.moneyType = item
      batInfo({ coin: this.moneyType }).then(res => {
        if (res.code == '200') {
          this.batInfoLists = res.data
        }
      })
    },
    async getUsdtBalance(address) {
      return new Promise((resolve, reject) => {
        this.axios.get('https://api.trongrid.io/v1/accounts/' + address).then(response => {

          let balance
          if (response && response.data.data[0]) {
            for (let i = 0; i < response.data.data[0].trc20.length; i++) {
              if (response.data.data[0].trc20[i].TR7NHqjeKQxGTCi8q8ZY4pL8otSzgjLj6t) {
                balance = response.data.data[0].trc20[i].TR7NHqjeKQxGTCi8q8ZY4pL8otSzgjLj6t
                resolve(balance || 0)
              }
            }
          } else {
            resolve(0)
          }
        })
      })
    },
    async getTrxBalance(address) {
      return new Promise((resolve, reject) => {
        this.axios.get('https://api.trongrid.io/v1/accounts/' + address).then(response => {
          if (response.data.data[0]) {
            resolve(response.data.data[0].balance || 0)
          }
        })
      })
    },
    //我的钱包查看更多
    moreWalletLists() {
      if (this.walletLists.length > 1) {
        this.show = true
      } else {
        this.$toast(this.$t('transactiondetails.not'))
      }
    },
    //佣金的转移
    toTransfer() {
      if (this.userInfo.payPwdStatus == '1') {
        this.$router.push('/transfer')
      } else {
        this.$router.push('/asset')
      }
    },
    about() {
      this.$router.push('/Privacypolicy?type=2')
    },
    myteam() {
      this.$router.push('/performance')
    },
    add_address() {
      this.$router.push('/add_address')
    },
    //钱包充值
    toBalance(type) {
      if (type == '0') {
        this.$router.push('/balance?type=' + type)
      } else {
        if (this.userInfo.payPwdStatus == '1') {
          this.$router.push('/balance?type=' + type)
        } else {
          this.$router.push('/asset')
        }
      }
    },
    //钱包提现
    withdrawal(name) {

      if (this.walletLists.length > 0) {
        if (this.userInfo.payPwdStatus == '1') {
          this.$router.push('/withdrawal?name=' + name)
        } else {
          this.$router.push('/asset')
        }
      } else {
        this.$router.push('/add_address')

      }
    },
    transactiondetails(item) {
      this.$router.push({
        path: '/transactiondetails',
        query: { address: item }
      })
    },
    bettingRecord() {
      clearInterval(this.balanceTimer)
      this.$router.push('/bettingRecord')
    },
    changeActiveStatus(item) {
      if (item == '1') {
        this.$router.push('/luckyhash')
      } else if (item == '2') {
        this.$router.push('/vip')
        // this.$toast(this.$t('transactiondetails.noopen'))
      } else if (item == '3') {
        this.$router.push('/spread')
      } else if (item == '4') {
        this.$router.push('/help')
      } else if (item == '5') {
      }
    },
    goCustomerLink() {
      //location.href = this.customer;
      window.open(this.customer, '_blank')
    },

    //用户头像设置页面
    toUserInfo() {
      clearInterval(this.balanceTimer)
      this.$router.push('/userInfo')
    },
    //用户个人信息设置页面
    toUserSettting() {
      clearInterval(this.balanceTimer)
      this.$router.push('/setting')
    },
    toSpread() {
      this.$router.push('/spread')
    },
    toVip() {

      this.$toast(this.$t('transactiondetails.noopen'))
    }
  }
}
</script>

<style lang="scss" scoped>
.user-user {
  width: 100vw;
  height: var(--height);
  background: #0c0b0b;

  .user-scroll {
    height: calc(var(--height) - 6.75rem);
    overflow-y: scroll;
  }

  .footer-tabbar {
    width: 100%;
    height: 3.125rem;
    background: #161414;
  }

  .other-about {
    padding: 0 0.9375rem 1rem;
    background: #0c0b0b;

    .other-about-item {
      height: 3rem;
      display: flex;
      align-items: center;
      border-bottom: 0.0625rem solid #272727;

      >img {
        width: 1.5rem;
        height: 1.5rem;
      }

      >p {
        font-size: 0.8125rem;
        font-family: PingFang SC-Medium, PingFang SC;
        font-weight: 500;
        color: #ffffff;
        padding-left: 0.5rem;
      }
    }
  }

  .my-group {
    padding: 0.9375rem;
    border-bottom: 0.375rem solid #060505;
    border-top: 0.375rem solid #060505;
    background: #0c0b0b;

    .top {
      display: flex;
      align-items: center;
      justify-content: space-between;
      padding-bottom: 0.625rem;

      >p:nth-child(1) {
        font-size: 1rem;
        font-family: PingFang SC-Medium, PingFang SC;
        font-weight: 500;
        color: #ffffff;
      }

      >p:nth-child(2) {
        font-size: 0.75rem;
        font-family: PingFang SC-Medium, PingFang SC;
        font-weight: 500;
        color: #999999;
      }
    }

    .win {
      .win-card {
        background: #110E31;
        border-radius: 0.625rem;
        padding: 0.9375rem;
        display: flex;
        align-items: center;
        justify-content: space-between;
        margin-top: 1.25rem;

        >div {
          >div:nth-child(1) {
            font-size: 0.8125rem;
            font-family: PingFang SC-Bold, PingFang SC;
            font-weight: bold;
            color: #ffffff;
            padding-bottom: 0.3125rem;
          }

          >div:nth-child(2) {
            font-size: 0.75rem;
            font-family: PingFang SC-Medium, PingFang SC;
            font-weight: 500;
            color: #999999;
          }
        }

        >img {
          width: 1.8125rem;
          height: 1.8125rem;
        }
      }
    }

    .money {
      display: flex;

      .active {
        color: #ffc400 !important;
        border-bottom: 0.0625rem solid #ffc400;
      }

      >p {
        font-size: 0.875rem;
        font-family: PingFang SC-Medium, PingFang SC;
        font-weight: 500;
        color: #999999;
        padding-bottom: 0.25rem;
        margin-right: 3.75rem;
      }
    }
  }

  .menu-lists {
    display: flex;
    justify-content: space-between;
    padding: 1.25rem 0.9375rem;

    >div {
      display: flex;
      flex-direction: column;
      align-items: center;
      // justify-content: center;
      flex: 1;
      max-width: 3.5rem;

      >img {
        width: 2.625rem;
        height: 2.5rem;
      }

      >p {
        display: block;
        max-width: 3.5rem;
        font-size: 0.8125rem;
        font-family: PingFang SC-Regular, PingFang SC;
        font-weight: 400;
        color: #ffffff;
        text-align: center;
        white-space: nowrap;
        overflow: hidden;
      }
    }
  }

  .add-my-wallet {
    padding: 0 0.9375rem;

    >div {
      width: 100%;
      background: #110E31;
      border-radius: 0.625rem;
    }

    .top {
      display: flex;
      justify-content: space-between;
      padding: 0.9375rem 0.9375rem 0;

      >p {
        font-size: 0.8125rem;
        font-family: PingFang SC-Medium, PingFang SC;
        font-weight: 500;
        color: #999999;
      }
    }

    .bottom {
      display: flex;
      align-items: center;
      justify-content: center;
      padding-bottom: 0.9375rem;

      >p {
        font-size: 0.6875rem;
        font-family: PingFang SC-Regular, PingFang SC;
        font-weight: 400;
        color: #555555;
      }
    }

    .center {
      display: flex;
      align-items: center;
      justify-content: space-between;
      padding: 0.625rem 0.9375rem 1.25rem;

      .code {
        font-size: 0.75rem;
        font-family: PingFang SC-Medium, PingFang SC;
        font-weight: 500;
        color: #666666;
      }

      .number {
        display: flex;
        align-items: center;

        >p {
          font-size: 0.8125rem;
          font-family: PingFang SC-Medium, PingFang SC;
          font-weight: 500;
        }

        >p:nth-child(1) {
          color: #ffffff;
        }

        >p:nth-child(2) {
          color: #ffc400;
        }
      }
    }
  }

  .my-wallet {
    padding: 1.25rem 0.9375rem 0.9375rem;
    display: flex;
    align-items: center;

    .my-wallet-left {
      font-size: 1rem;
      font-family: PingFang SC-Medium, PingFang SC;
      font-weight: 500;
      color: #ffffff;
    }

    .my-wallet-right {
      margin-left: auto;
      display: flex;
      align-items: center;

      >img {
        width: 1.1875rem;
        height: 1.4375rem;
      }

      >p {
        font-size: 0.75rem;
        font-family: PingFang SC-Medium, PingFang SC;
        font-weight: 500;
        color: #999999;
        padding-left: 0.3125rem;
      }
    }
  }

  .user-card-other {
    padding: 0 0.9375rem;
    margin: 0 0 1.5625rem 0;

    >div {
      width: 100%;
      background-image: url('../assets/yjzh.png');
      background-position: center center;
      background-size: 100% 100%;
      background-repeat: no-repeat;
      border-radius: 0.625rem;

      .card-bottom {
        display: flex;
        justify-content: center;
        padding: 1.75rem 0 0.9375rem;

        >div {
          width: 6.25rem;
          height: 1.875rem;
          background: #ffc400;
          border-radius: 1.1875rem;
          margin: 0 1.1875rem;
          display: flex;
          align-items: center;
          justify-content: center;

          >p {
            width: 4.25rem;
            font-size: 0.875rem;
            font-family: PingFang SC-Medium, PingFang SC;
            font-weight: 500;
            color: #0c0b0b;
            overflow: hidden;
            white-space: nowrap;
            text-align: center;
          }
        }
      }

      .card-center {
        padding: 0 2.6875rem;
        display: flex;

        >div {
          font-size: 1rem;
          font-family: PingFang SC-Heavy, PingFang SC;
          font-weight: 800;
          color: #ffffff;
          flex: 1;
          text-align: center;
        }

        >div:nth-child(2) {
          border-left: 0.0625rem solid #ffffff;
        }
      }

      .card-top {
        display: flex;
        align-items: center;
        justify-content: space-between;
        padding: 0.6875rem 0;

        >div:nth-child(1) {
          width: 4rem;
        }

        >div:nth-child(2) {
          font-size: 0.75rem;
          font-family: PingFang SC-Regular, PingFang SC;
          font-weight: 400;
          color: #ffffff;
        }

        >div:nth-child(3) {
          width: 4rem;
          height: 1.5625rem;
          background: rgba(255, 255, 255, 0.1);
          border-radius: 0.8125rem 0px 0px 0.8125rem;
          display: flex;
          align-items: center;
          justify-content: center;

          >p {
            font-size: 0.75rem;
            font-family: PingFang SC-Medium, PingFang SC;
            font-weight: 500;
            color: #999999;
          }
        }
      }
    }
  }

  .user-card {
    padding: 0 0.9375rem;

    // margin-top: 1.5625rem;
    >div {
      width: 100%;
      background: linear-gradient(136deg, #ffdb67 0%, #ffc400 100%);
      border-radius: 0.625rem;

      .card-bottom {
        display: flex;
        justify-content: center;
        padding: 1.75rem 0 0.9375rem;

        >div {
          width: 6.25rem;
          height: 1.875rem;
          background: #ffffff;
          border-radius: 1.1875rem;
          margin: 0 1.1875rem;
          display: flex;
          align-items: center;
          justify-content: center;

          >p {
            width: 4.25rem;
            font-size: 0.875rem;
            font-family: PingFang SC-Medium, PingFang SC;
            font-weight: 500;
            color: #ffc400;
            overflow: hidden;
            white-space: nowrap;
            text-align: center;
          }
        }
      }

      .card-center {
        padding: 0 2.6875rem;
        display: flex;

        >div {
          font-size: 1rem;
          font-family: PingFang SC-Heavy, PingFang SC;
          font-weight: 800;
          color: #ffffff;
          flex: 1;
          text-align: center;
        }

        >div:nth-child(2) {
          border-left: 0.0625rem solid #ffffff;
        }
      }

      .card-top {
        display: flex;
        align-items: center;
        justify-content: space-between;
        padding: 0.6875rem 0;

        >div:nth-child(1) {
          width: 4rem;
        }

        >div:nth-child(2) {
          font-size: 0.75rem;
          font-family: PingFang SC-Regular, PingFang SC;
          font-weight: 400;
          color: #ffffff;
        }

        >div:nth-child(3) {
          width: 4rem;
          height: 1.5625rem;
          background: rgba(255, 255, 255, 0.33);
          border-radius: 0.8125rem 0px 0px 0.8125rem;
          display: flex;
          align-items: center;
          justify-content: center;

          >p {
            font-size: 0.75rem;
            font-family: PingFang SC-Medium, PingFang SC;
            font-weight: 500;
            color: #c18700;
          }
        }
      }
    }
  }

  .userInfo {
    padding: 0.9375rem;
    display: flex;
    align-items: center;

    .header {
      width: 3.875rem;
      height: 3.875rem;
      background: rgba(255, 255, 255, 0.5);
      border-radius: 50%;
    }

    >img {
      width: 3.875rem;
      height: 3.875rem;
      background: #ffffff;
      border-radius: 50%;
    }

    .userInfo-center {
      margin-left: 1rem;

      >div {
        font-family: PingFang SC-Regular, PingFang SC;
        font-weight: 400;
      }

      >div:nth-child(1) {
        color: #ffffff;
        font-size: 1rem;
        padding-bottom: 0.375rem;
      }

      >div:nth-child(2) {
        color: #ffffff;
        font-size: 0.8125rem;
      }
    }
  }

  .index-view-top {
    height: 3.625rem;
    padding: 0 0.9375rem;
    display: flex;
    align-items: center;
    justify-content: space-between;

    .title {
      font-size: 1.125rem;
      font-family: PingFang SC-Bold, PingFang SC;
      font-weight: bold;
      color: #ffffff;
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/user/user.vue